var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _path8, _path9, _path10, _path11, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTmetricBlogLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 80,
    viewBox: "0 0 220 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89.1878 33.9823H83V30.3359H99.8508V33.9823H93.663V49.673H89.1878V33.9823V33.9823Z",
    fill: "#3A3E42"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M120.202 49.6651L120.173 38.0629L114.483 47.6209H112.467L106.804 38.3115V49.6651H102.605V30.3281H106.307L113.545 42.3433L120.672 30.3281H124.346L124.4 49.6651H120.202Z",
    fill: "#3A3E42"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M144.308 46.074V49.6651H129.336V30.3281H143.949V33.9193H133.783V38.1182H142.761V41.6002H133.783V46.0754H144.308V46.074Z",
    fill: "#3A3E42"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M152.223 33.9745H146.035V30.3281H162.886V33.9745H156.7V49.6651H152.224V33.9745H152.223Z",
    fill: "#3A3E42"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M177.952 49.6651L174.223 44.2784H170.108V49.6651H165.633V30.3281H174.003C175.716 30.3281 177.198 30.614 178.45 31.1845C179.721 31.7563 180.698 32.5657 181.38 33.6154C182.061 34.6651 182.401 35.9082 182.401 37.3447C182.401 38.7812 182.051 40.0243 181.351 41.074C180.67 42.1058 179.694 42.8972 178.423 43.4511L182.761 49.6665H177.952V49.6651ZM177.869 37.3447C177.869 36.2577 177.521 35.4303 176.819 34.8585C176.12 34.2687 175.098 33.9745 173.753 33.9745H170.107V40.7149H173.753C175.098 40.7149 176.12 40.4207 176.819 39.8309C177.521 39.2411 177.869 38.4124 177.869 37.3447Z",
    fill: "#3A3E42"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M186.289 30.3281H190.764V49.6651H186.289V30.3281Z",
    fill: "#3A3E42"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M204.954 50C202.983 50 201.197 49.576 199.595 48.7293C198.012 47.8633 196.756 46.6754 195.837 45.1657C194.935 43.6367 194.484 41.9144 194.484 40C194.484 38.0856 194.935 36.3715 195.837 34.8619C196.756 33.3329 198.011 32.145 199.595 31.2983C201.197 30.4337 202.993 30 204.982 30C206.657 30 208.167 30.2942 209.511 30.884C210.872 31.4724 212.015 32.3204 212.936 33.4254L210.063 36.0773C208.755 34.5677 207.135 33.8122 205.201 33.8122C204.004 33.8122 202.935 34.0787 201.997 34.6133C201.058 35.1298 200.319 35.8564 199.787 36.7956C199.269 37.7348 199.012 38.8039 199.012 40C199.012 41.1961 199.269 42.2652 199.787 43.2044C200.319 44.1436 201.058 44.8798 201.997 45.4144C202.936 45.9296 204.004 46.1892 205.201 46.1892C207.134 46.1892 208.754 45.4226 210.063 43.8964L212.936 46.5483C212.013 47.6713 210.872 48.5276 209.511 49.116C208.149 49.7044 206.629 50 204.954 50Z",
    fill: "#3A3E42"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39 72C56.6731 72 71 57.6731 71 40C71 22.3269 56.6731 8 39 8C21.3269 8 7 22.3269 7 40C7 57.6731 21.3269 72 39 72Z",
    fill: "white"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4216 51.1348C45.0789 52.9095 42.1603 53.9655 38.9936 53.9655C35.8109 53.9655 32.8789 52.8988 30.5309 51.1055L23.4336 58.1255C27.6149 61.7175 33.0483 63.8948 38.9936 63.8948C44.9109 63.8948 50.3229 61.7388 54.4949 58.1748L47.4216 51.1348Z",
    fill: "#04ADE0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5532 36.6389C52.8199 37.7175 52.9639 38.8429 52.9639 40.0015C52.9639 43.1442 51.9239 46.0455 50.1719 48.3789L57.2452 55.4202C60.8745 51.1242 62.8945 45.6655 62.8945 40.0015C62.8945 36.1389 61.9519 32.3682 60.1999 28.9922L52.5532 36.6389Z",
    fill: "#F54949"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8027 48.3376C26.0654 46.0096 25.0374 43.1229 25.0374 39.9962C25.0374 32.2842 31.2894 26.0322 39.0014 26.0322C41.232 26.0322 43.3374 26.5576 45.208 27.4869L52.42 20.2749C48.5854 17.6469 43.96 16.1016 39.0027 16.1016C25.8947 16.1016 15.1094 26.8882 15.1094 39.9949C15.1094 45.6322 17.1094 51.0669 20.7094 55.3536L27.8027 48.3376Z",
    fill: "#00BC6A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M37.624 45.7502C37.0027 45.7502 36.38 45.5128 35.9053 45.0395L31.212 40.3448C30.2627 39.3968 30.2627 37.8582 31.212 36.9102C32.16 35.9608 33.6987 35.9608 34.648 36.9102L37.6227 39.8835L56.608 20.8995C57.556 19.9502 59.096 19.9502 60.044 20.8995C60.9933 21.8475 60.9933 23.3862 60.044 24.3355L39.3413 45.0382C38.868 45.5128 38.2467 45.7502 37.624 45.7502Z",
    fill: "#37474F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 3,
    y: 6,
    width: 72,
    height: 72,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTmetricBlogLogo);
export default __webpack_public_path__ + "static/media/tmetric-blog-logo.324367dd61883c125d853e78b2530786.svg";
export { ForwardRef as ReactComponent };